const HTML = `
    <div id="dev-root" class="fixed top-0 right-0 font-mono bg-white">
        <div>
            ID: <span id="dev-sweep-id"></span>
        </div>
        <div>
            Rotation: X: <span id="dev-rotation-x"></span> Y: <span id="dev-rotation-y"></span>
        </div>
        <button type="button" id="dev-screenshot">Screenshot</button>
    </div>
`;

export default function (sdk) {
    const elements = injectHtml();

    let sweepId;
    let rotation;

    sdk.Sweep.current.subscribe(currentSweep => {
        sweepId = currentSweep.sid;
        elements.sweepId.textContent = sweepId;
    });

    sdk.Camera.pose.subscribe(pose => {
        rotation = {
            x: pose.rotation.x.toFixed(2),
            y: pose.rotation.y.toFixed(2)
        };

        elements.rotationX.textContent = rotation.x;
        elements.rotationY.textContent = rotation.y;
    });

    elements.root.addEventListener("click", ev => {
        ev.preventDefault();
        navigator.clipboard.writeText(`${sweepId}:${rotation.x},${rotation.y}`)
            .then(() => console.log("Copied sweep data."))
            .catch(() => alert("Failed to copy sweep data."));
    });

    elements.screenshotBtn.addEventListener("click", ev => {
        ev.preventDefault();
        sdk.Renderer.takeScreenShot({ width: 4096, height: 4096 }, {
            mattertags: false,
            sweeps: false,
        }).then(uri => {
            const link = document.createElement("a");
            link.download = "jhh-screenshot.jpg";
            link.href = uri;

            document.body.appendChild(link);
            link.click();
            link.remove();
        });
    });
}

function injectHtml() {
    const fragment = document.createRange().createContextualFragment(HTML);

    const elements = {};
    elements.root = fragment.getElementById("dev-root");
    elements.sweepId = fragment.getElementById("dev-sweep-id");
    elements.rotationX = fragment.getElementById("dev-rotation-x");
    elements.rotationY = fragment.getElementById("dev-rotation-y");

    elements.screenshotBtn = fragment.getElementById("dev-screenshot");

    document.body.appendChild(fragment);

    return elements;
}
